import type { ReactNode } from "react";
import { LogOut, Moon, Sun } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { authClient } from "../lib/platform";
import { Ship } from "./app-nav-model";
import { useTheme } from "./theme";

// A ghost icon button, NavioWorks-header style (h-8 square, muted → foreground on hover).
function IconButton({ label, onClick, children }: { label: string; onClick: () => void; children: ReactNode }) {
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      onClick={onClick}
      className="grid h-8 w-8 place-items-center rounded-md text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
    >
      {children}
    </button>
  );
}

// Top app bar, aligned with NavioWorks' Header: brand on the left, utility actions (theme + sign out) on the
// right. Sign out lives here now, not in the sidebar.
export function AppHeader() {
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();
  return (
    <header className="flex h-11 shrink-0 items-center border-b border-border bg-background px-3">
      <button onClick={() => navigate("/")} className="flex min-w-0 items-center gap-2 transition-opacity hover:opacity-80">
        <span className="grid size-6 shrink-0 place-items-center rounded bg-primary text-primary-foreground">
          <Ship size={14} aria-hidden="true" />
        </span>
        <span className="truncate text-base font-semibold tracking-tight text-foreground">NavioPlan</span>
        <span className="hidden text-sm text-muted-foreground sm:inline">Voyage intelligence</span>
      </button>
      <div className="flex-1" />
      <div className="flex items-center gap-1">
        <IconButton label={theme === "dark" ? "Light mode" : "Dark mode"} onClick={toggleTheme}>
          {theme === "dark" ? <Sun size={16} aria-hidden="true" /> : <Moon size={16} aria-hidden="true" />}
        </IconButton>
        <div className="mx-1 h-5 w-px bg-border" />
        <IconButton label="Sign out" onClick={() => void authClient.auth.signOut()}>
          <LogOut size={16} aria-hidden="true" />
        </IconButton>
      </div>
    </header>
  );
}
